import {TextStyle} from 'pixi.js';

export interface IAdvancedTextConfig {
    id: string;
    style: TextStyle;
    slot: string;
    position?: {x?: number; y?: number;};
    maxWidth?: number;
}